module.exports = __webpack_public_path__ + "static/media/ADANIPORTS.9b8f4aeb.txt";